module.exports = __webpack_public_path__ + "Contact-us-cp.961774a9df76d8a8f2b1.png";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/assets/images/Contact-us-cp.png
// module id = ../../../../../src/assets/images/Contact-us-cp.png
// module chunks = main